import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ErrorAlert } from 'smartsuite-ui/lib/alerts/ErrorAlert';

export default function FadeErrorAlert(props) {
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        if (props.showError) {
            setFadeIn(true);
        } else {
            setFadeIn(false);
        }
    }, [props.showError]);

    const className = fadeIn
        ? 'fade-error-container fade-error-container--visible'
        : 'fade-error-container';

    return (
        <div className={className}>
            <ErrorAlert>{props.children}</ErrorAlert>
        </div>
    );
}

FadeErrorAlert.propTypes = {
    children: PropTypes.node,
    showError: PropTypes.bool.isRequired,
};

FadeErrorAlert.defaultProps = {
    children: '',
};
